<div class="user-opinion">
    <form on:submit|preventDefault="{submitOpinion}">    
        <textarea bind:value="{opinion}" on:keydown="{submitOnEnter}" placeholder="What's your reason?" name="opinion" class="form-control form-control-lg" ></textarea>
        <input type="submit" value="Save" class="btn btn-primary form-control-lg form-control">
    </form>
    <p class="text-small">Anonymously let others know  what's important about this product, how it can be used, and why buy it.</p>

</div>


<script>
    export let pid, oid, uid;
    let opinion = ''
    

    import utils from '../../common/utils'
    import { onMount } from 'svelte';



    onMount(async () => {
        if(pid) {
            loadUserOpinion({oid, uid, pid})
        }
    })

    function loadUserOpinion(args) {
        utils.postData('/wapi/seacoast/v1/getUserOpinion', args, function(resp) {
            if(resp.opinion) opinion = resp.opinion
            if(resp.oid) oid = resp.oid
        })
    }
    
    function submitOpinion() {
        utils.postData('/wapi/seacoast/v1/postOpinion', {pid, opinion, uid, oid}, function(resp) {
            alert('Thank you, we have received your opinion');
            oid = resp.oid
        })

    }

    function submitOnEnter(ev) {
        if(ev.keyCode==13) {ev.preventDefault(); submitOpinion();return false; }
        return true;
    }

</script>

<style>


</style>


